import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useStore } from 'stores';
import Select from 'components/Select';
import { getAiSMStrategyProfile } from 'api/strategy';

export default function StrategySelect() {
  const { t } = useTranslation();

  const currentEmail = useStore((state) => state.currentEmail);
  const currentStrategy = useStore((state) => state.currentStrategy);
  const setCurrentStrategy = useStore((state) => state.setCurrentStrategy);
  const strategyList = useStore((state) => state.strategyList);
  const setStrategyList = useStore((state) => state.setStrategyList);
  const dynamicProfitOrderby = useStore((state) => state.dynamicProfitOrderby);
  const [options, setOptions] = useState([]);

  useEffect(() => {
    async function fetch() {
      const res = await getAiSMStrategyProfile(currentEmail);
      setCurrentStrategy(res?.[0]);
      setStrategyList(res);
    }
    fetch();
  }, [currentEmail, setCurrentStrategy, setStrategyList]);

  useEffect(() => {
    if (dynamicProfitOrderby.length === 0 || strategyList.length === 0) {
      return;
    }
    let list = dynamicProfitOrderby.map(({ strategyProfileId }) =>
      strategyList.find(({ StrategyProfileId: id }) => id === strategyProfileId)
    );

    setOptions(list);
  }, [dynamicProfitOrderby, strategyList]);

  return (
    <Select
      title={t('AllStock.strategy')}
      options={options}
      type="strategy"
      value={currentStrategy?.StrategyProfileId}
      onSelectChange={(e) => {
        setCurrentStrategy(
          strategyList.find(({ StrategyProfileId }) => StrategyProfileId === Number(e.target.value))
        );
      }}
      className="flex-1"
    />
  );
}
